import request from '@/utils/request'

// api地址
const api = {
  all: '/frm/sceneLuck',
  save: '/frm/sceneLuck',
  update: '/frm/sceneLuck/update',
  delete: '/frm/sceneLuck/',
  deleteBatch: '/frm/sceneLuck/batch',
  page: '/frm/sceneLuck/page',
  createLuckUser: '/frm/user/scene/luck/user/create',
  resetLuckUser: '/frm/user/scene/luck/user/reset'
}

/**
 * 查询所有
 * @param params 参数
 * @returns {Promise<Array>}
 */
export function all(params) {
  return new Promise((resolve, reject) => {
    request.get(api.all, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}

/**
 * 查询列表
 * @param params 参数
 * @returns {Promise<Array>}
 */
export function page(params) {
  return new Promise((resolve, reject) => {
    request.get(api.page, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}
/**
 * 添加或修改
 * @param data 参数
 * @returns {Promise<>}
 */
export function save(data, isUpdate) {
  if (isUpdate) {
    return new Promise((resolve, reject) => {
      request.post(api.update, data).then(res => {
        resolve(res.data)
      }).catch(e => {
        reject(e)
      })
    })
  } else {
    return new Promise((resolve, reject) => {
      request.post(api.save, data).then(res => {
        resolve(res.data)
      }).catch(e => {
        reject(e)
      })
    })
  }
}
/**
 * 根据id删除
 * @param id id
 * @returns {Promise<>}
 */
export function deleteById(id) {
  return new Promise((resolve, reject) => {
    request.delete(api.delete + id).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}

/**
 * 批量删除
 * @param id id
 * @returns {Promise<>}
 */
export function deleteBatch(data) {
  return new Promise((resolve, reject) => {
    request.delete(api.deleteBatch, data).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}

export function createLuckUser(data) {
  return new Promise((resolve, reject) => {
    request.post(api.createLuckUser, data).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}

export function resetLuckUser(data) {
  return new Promise((resolve, reject) => {
    request.post(api.resetLuckUser, data).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}
